import { Calendar, Compass, GraduationCap, UtensilsCrossed, Sparkles, type LucideIcon } from 'lucide-react';

/**
 * Central mapping for activity type → label, description, icon.
 * Single source of truth used in both the create-sheet and the read-only wizard view.
 */
export interface ActivityTypeMeta {
  value: string;
  label: string;
  description: string;
  icon: LucideIcon;
}

export const ACTIVITY_TYPE_META: ActivityTypeMeta[] = [
  { value: 'event', label: 'Event', description: 'En aktivitet som kan ske vid ett datum, löpande eller under en säsong.', icon: Calendar },
  { value: 'course', label: 'Kurs', description: 'Lärande upplevelse som sker vid ett eller flera tillfällen', icon: GraduationCap },
  { value: 'outing', label: 'Utflykt', description: 'Kan upplevas när som helst, utan bokning', icon: Compass },
  { value: 'dinner', label: 'Middag / Provning', description: 'Mat- eller dryckesupplevelse', icon: UtensilsCrossed },
  { value: 'workshop', label: 'Workshop', description: 'Praktiskt skapande', icon: Sparkles },
];

export function getActivityTypeMeta(type: string): ActivityTypeMeta | undefined {
  return ACTIVITY_TYPE_META.find((t) => t.value === type);
}
